import i18n from '~/i18n';
import { PATH_DASHBOARD, PATH_INVOICES_OVERVIEW } from '~/router';

const defaultConfig = {
  account: {
    visible: true,
  },
  backButton: {
    path: PATH_DASHBOARD,
  },
  contacts: {
    visible: true,
    text: i18n.t('header.contacts'),
  },
  createInvoiceButton: {
    text: i18n.t('button.createInvoice'),
  },
  dashboard: {
    visible: true,
    text: i18n.t('header.dashboard'),
  },
  expenses: {
    visible: true,
    text: i18n.t('header.expenses'),
  },
  invoices: {
    visible: true,
    text: i18n.t('header.invoices'),
  },
  reports: {
    visible: true,
    text: i18n.t('header.reports'),
  },
};

export const navbarConfig = {
  default: {
    ...defaultConfig,
  },
  usa: {
    ...defaultConfig,
    backButton: {
      path: PATH_INVOICES_OVERVIEW,
    },
    contacts: {
      visible: true,
      text: i18n.t('header.customers'),
    },
    createInvoiceButton: {
      text: i18n.t('button.createDocument'),
    },
    dashboard: {
      visible: false,
    },
    expenses: {
      visible: false,
    },
    invoices: {
      visible: true,
      text: i18n.t('header.documents'),
    },
    reports: {
      visible: false,
    },
  },
};
